import React from 'react';
import { useSelector } from 'react-redux';
import { useThemes, useUserRoleAllowed } from '@core/hooks';
import { HandledNavLink } from '@core/components';
import { Item } from 'devextreme-react/toolbar';
import { paths } from '@modules/raccoon/src/routes/app-paths';

const RenderUnreadMessagesInfo = () => {
  const { isDark } = useThemes();
  const { totalCount } = useSelector((state) => state.signalRTyp);

  return totalCount > 0 ? (
    <HandledNavLink
      to={paths.KomunikatoryPage}
      className="user-panel-wiadomosci-wrapper"
    >
      <div className="userPanelWiadomosci">
        <i
          className={`dx-icon-message ${
            !isDark ? 'dx-icon-message--light' : ''
          }`}
        />
        <span className="userPanelWiadomosci__badge">{totalCount}</span>
      </div>
    </HandledNavLink>
  ) : null;
};

const MsgsHeaderItem = (key) => {
  const showMsgsNotification = useUserRoleAllowed([1, 2, 32]);

  return (
    <Item key={key} location="after" visible={showMsgsNotification}>
      <RenderUnreadMessagesInfo />
    </Item>
  );
};

export default MsgsHeaderItem;
